import { render, staticRenderFns } from "./DateRangeText.vue?vue&type=template&id=cd4e3c06&scoped=true"
import script from "./DateRangeText.vue?vue&type=script&lang=js"
export * from "./DateRangeText.vue?vue&type=script&lang=js"
import style0 from "./DateRangeText.vue?vue&type=style&index=0&id=cd4e3c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4e3c06",
  null
  
)

export default component.exports